import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, RadioGroup, FormControlLabel, Radio, Button } from '@mui/material';
import { Info } from 'lucide-react';

// Props:
// open: boolean
// onClose: function
// onSave: function (agentValue)
// selectedAgent: string ('cloudAgent' | 'localAgent')
// extensionInstalled: boolean

const AgentSelectionDialog = ({ open, onClose, onSave, selectedAgent, extensionInstalled }) => {
  const [tempAgent, setTempAgent] = useState(selectedAgent || 'cloudAgent');

  useEffect(() => {
    setTempAgent(selectedAgent || 'cloudAgent');
  }, [selectedAgent, open]);

  const handleSave = () => {
    onSave(tempAgent);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Run API On{' '}
        <Tooltip title={<div className='text-sm'>
          <b>Cloud Agent:</b> The API will run on our server.<br /><br />
          <b>Local Agent:</b> The API will run on your local system using our extension.
        </div>}>
          <span style={{ verticalAlign: 'middle' }}><Info size={16} /></span>
        </Tooltip>
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          value={tempAgent}
          onChange={e => setTempAgent(e.target.value)}
          name="agent-selection"
        >
          <FormControlLabel value="cloudAgent" control={<Radio />} label="Cloud Agent" />
          <FormControlLabel value="localAgent" control={<Radio />} label="Local Agent" disabled={!extensionInstalled} />
        </RadioGroup>
        {!extensionInstalled && (
          <div className='mt-2'>
            <span className='text-[var(--text-primary)]'>Looks like the extension is not installed.  <a href="https://chromewebstore.google.com/detail/qodex-api-testing-tool/gnhoedmgmepgeibnjkganjadamgblemk" target="_blank" rel="noopener noreferrer" className='text-blue-600'>Download Now</a> to use the Local Agent.</span>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color='error' onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentSelectionDialog; 